import LeadFinderSubscriptionPlan, {
  planToUpgradePlansMap,
} from "@mapmycustomers/shared/enum/LeadFinderSubscriptionPlan";

import Feature, { featurePlanMap } from "@app/enum/Feature";

import isFeatureEnabled, { AddOnServices, leadFinderPlanByFeature } from "./isFeatureEnabled";

export enum FeatureCardState {
  // The org has it. Renders in the current-features panel.
  OWNED = "owned",
  // The org can buy it. Renders in its plan band.
  AVAILABLE = "available",
  // Renders nowhere: a card no plan includes, or a Lead Finder tier at or below the org's own.
  HIDDEN = "hidden",
}

const getFeatureCardState = (feature: Feature, addOnServices: AddOnServices): FeatureCardState => {
  if (isFeatureEnabled(feature, addOnServices)) {
    return FeatureCardState.OWNED;
  }

  // No band includes it, so there is nowhere to sell it.
  if (!featurePlanMap[feature]) {
    return FeatureCardState.HIDDEN;
  }

  const leadFinderPlan = leadFinderPlanByFeature[feature];
  if (leadFinderPlan) {
    // planToUpgradePlansMap already encodes the whole ladder, including that Basic and Pro
    // are only ever offered Elite, and that Elite is offered nothing.
    const offeredPlans = planToUpgradePlansMap[addOnServices.leadGen] ?? [];
    return (offeredPlans as readonly LeadFinderSubscriptionPlan[]).includes(leadFinderPlan)
      ? FeatureCardState.AVAILABLE
      : FeatureCardState.HIDDEN;
  }

  return FeatureCardState.AVAILABLE;
};

export default getFeatureCardState;
